import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiServiceService} from "../../../../Services/api-service.service";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {Location} from "@angular/common";
import {SuccessDialogComponent} from "../../../../Shared/shared/success-dialog/success-dialog.component";
import {ErrorDialogComponent} from "../../../../Shared/shared/error-dialog/error-dialog.component";
import * as alertify from "alertifyjs";

@Component({
  selector: 'app-non-tax-eddit',
  templateUrl: './non-tax-eddit.component.html',
  styleUrls: ['./non-tax-eddit.component.css']
})
export class NonTaxEdditComponent {

  @Output() onConfirmClicked = new EventEmitter();
  @Input() details: any;

  expiryYear: any
  form: FormGroup;
  isLoading: boolean | undefined;
  isEmpty: boolean | undefined;
  isDownloading: boolean;
   amount: number =0;
   renewalAmount: number=0;
   name: any;
   assessmentId: any;


  constructor(
      private route: ActivatedRoute,
      private apiService: ApiServiceService,
      private bsModalService: BsModalService,
      private bsModalRef: BsModalRef,
      private location: Location,
      private router: Router,
      private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      assessmentId: [''],
      type: ['APPROVED'],
      assessmentClass: [''],
    });
  }

  ngOnInit(): void {
    if (this.details.assessmentType == 'BUSINESS_PREMISES') {
      this.getAllBusinessPremisesType();
    }
    if (this.details.assessmentType == 'ASWAMA') {
      this.getAllBuildingTypes();
    }
    if (this.details.assessmentType == 'FIRE_SERVICE') {
      this.getAllBuildingTypes();
    }
    if (this.details.assessmentType == 'PRESUMPTIVE_TAX') {
      this.getAllIncomeTypes();
    }
  }



  testReport() {
    const url = "/assessments/get/report";
    this.apiService.get(url).subscribe(
        (response) => {

        },
        (error) => {
          console.log(error);
        }
    );

  }

  close() {
    this.onConfirmClicked.emit();
    this.bsModalRef.hide();
  }


  submit(){
    this.isDownloading = true;
    const details ={
        assessmentId: this.details.assessmentId,
        amount:  this.details?.regType == 'REGISTRATION' ? this.amount: this.renewalAmount > 0 ? this.renewalAmount : this.amount,
        renewalAmount: this.renewalAmount,
        assessmentName:this.name,
        category: this.assessmentId,
    }

    let url = "/assessments/update/non/assessment"

    this.apiService.post(url, details).subscribe(
        (response) => {
          this.isDownloading = false;
          this.confirmAfterSuccess(response.message);
        },
        (error) => {
            console.log(error);
            this.isDownloading = false;
          this.confirmAfterError(error.message);

        }
    );
  }

  goBack() {
    this.location.back();
  }

  confirmAfterSuccess(message: any) {
    let dfModalRef = this.bsModalService.show(SuccessDialogComponent, {
      initialState: {
        body: message,
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      dfModalRef.hide();
    });
  }



  confirmAfterError(message: any) {
    let dfModalRef = this.bsModalService.show(ErrorDialogComponent, {
      initialState: {
        body: message,
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      dfModalRef.hide();
    });
  }


  businessPremisesIncomeTypes: any;

  getAllBusinessPremisesType() {
    let url = "/auth/profiling/business_premises_types/";
    this.apiService.LoginGet(url).subscribe(
        (response) => {
          console.log(response);
          this.businessPremisesIncomeTypes = response.data;
        },
        (error) => {
          console.log(error);
        }
    );
  }

  items:any;
  getBusinessPremisesSubType(detail:any) {
    const items = detail.target.value.split('_')
    this.amount = items[2];
    this.renewalAmount = items[3];
    this.name = items[1];
    this.assessmentId = items[0];
  }


  buildingTypes: any;
  buildingTypeSubs: any;
  buildingTypeSubsTypes: any;

  getAllBuildingTypes() {
    const url = "/auth/profiling/building_types";
    this.apiService.LoginGet(url).subscribe(
        (response) => {
          this.buildingTypes = response.data;
        },
        (error) => {
          console.log(error);
        }
    );
  }


  aswamaTypes: any;
  getAllBuildingTypesSub(id:any) {
    this.aswamaTypes = id.target.value.split('_')[1]
    const items = id.target.value.split('_')
    const url = `/auth/profiling/building_sub_types/${items[0]}`;
    this.apiService.LoginGet(url).subscribe(
        (response) => {
          this.buildingTypeSubs = response.data;
        },
        (error) => {
          console.log(error);
        }
    );
  }

  getAllBuildingTypesSubTypes(id:any) {
    const item = id.target.value.split('_')
    this.amount = item[2];
    this.name = item[1];
    this.assessmentId = item[0];
    console.log(item)

    const url = `/auth/profiling/building_sub_types_sub/${item[0]}`;
    this.apiService.LoginGet(url).subscribe(
        (response) => {
          console.log(response);
          this.buildingTypeSubsTypes = response.data;
        },
        (error) => {
          console.log(error);
        }
    );
  }

  getSubTypeAswama(id: any) {
    const items = id.target.value.split('_')
    this.amount = items[2];
    this.name = items[1];
    this.assessmentId = items[0];
    console.log(items)
  }

  incomeTypes: any;
  getAllIncomeTypes() {
    let url = "/auth/profiling/income_types/all";

    this.apiService.LoginGet(url).subscribe(
        (response) => {
          this.incomeTypes = response.data;
          console.log(response.data)
        },
        (error) => {
          console.log(error);
        }
    );
  }

  classification: any;
  getIncomeClassificationByIncomeTypeAndCategory(id:any) {
    console.log(id.target.value)
    let url = `/auth/profiling/income_classification/${this.presumptiveTaxId}/${id.target.value}`;

    this.apiService.LoginGet(url).subscribe(
        (response) => {
          console.log(response.data);
          this.classification = response.data;
          this.amount = this.classification?.price
          this.name = this.presumptiveTaxName + " (" + this.classification?.category + ")"
          this.assessmentId = this.classification?.id;
        },
        (error) => {
          console.log(error);
        }
    );
  }

  presumptiveTaxId: any;
  presumptiveTaxName: any;
  getPresumptiveTax(id: any) {
    const items = id.target.value.split('_')
    this.presumptiveTaxId = items[0];
    this.presumptiveTaxName = items[1];
  }
}
